import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	CreateCommentMutation,
	CreateCommentMutationVariables,
} from "~/types/__generated/gql/graphql";
import {
	getCommentsByFileIdQueryKey,
	GetCommentsByFileIdResults,
} from "../useGetCommentsByFileId";
import { useAppRouter } from "~/hooks/use-app-router";

const query = /* GraphQL */ `
	mutation CreateComment($input: CreateCommentInput!) {
		createComment(input: $input) {
			_id
			createdAt
			updatedAt
			user
			text
			attachments {
				name
				size
				url
				extension
			}
			comment

			_user {
				firstName
				lastName
				avatar
			}
		}
	}
`;

export type CreateCommentVariables = CreateCommentMutationVariables;
export type CreateCommentResults = CreateCommentMutation["createComment"];

export const useCreateComment = () => {
	const queryClient = useQueryClient();
	const { appQuery } = useAppRouter();

	return useMutation({
		mutationFn: (variables: CreateCommentVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.createComment),
		onSuccess: (data) => {
			queryClient.setQueryData<GetCommentsByFileIdResults>(
				getCommentsByFileIdQueryKey(appQuery.fileId!),
				(oldData) => (oldData ? [data, ...oldData] : [data]),
			);
		},
	});
};
